export const mapReleaseFrequency = (releaseFrequency: string) => {
    switch (releaseFrequency) {
        case 'Once':
            return 'once';
        case 'Daily':
            return 'daily';
        case 'Three times a week':
            return 'threeTimesAWeek';
        case 'Twice a week':
            return 'twiceAWeek';
        case 'Weekly':
            return 'weekly';
        case 'Every two weeks':
            return 'everyTwoWeeks';
        case 'Three times a month':
            return 'threeTimesAMonth';
        case 'Twice a month':
            return 'twiceAMonth';
        case 'Monthly':
            return 'monthly';
        case 'Every two months':
            return 'everyTwoMonths';
        case 'Quarterly':
            return 'quarterly';
        case 'Three times a year':
            return 'threeTimesAYear';
        case 'Twice a year':
            return 'twiceAYear';
        case 'Annually':
            return 'annually';
        case 'Irregularly':
            return 'irregularly';
        default:
            return '';
    }
};
